import React from "react";

function Footer() {
  return (
    <footer className="border-t border-gray-800 py-8 px-4 bg-black text-center">
      <p className="text-gray-400 font-semibold">
        © 2025 Andrew Poudel. All rights reserved. |{" "}
        <span className="text-green-400">Building Excellence Together</span>
      </p>
    </footer>
  );
}

export default Footer;
